<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">スタートアップはどのように市場の乱高下に備えるべきか

</h1>

                <span class="meta"> Posted in May 2022 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/turbulence_bw.png" alt="">
                </figure>
                
<p><strong>日本のスタートアップ創業者の皆様</strong></p>



<p>皆さんの多くは黙々と変革的なプロジェクトを推進することに集中しているであろう。プロジェクトに集中することは良いことであり、マクロ経済の動向に惑わされないことが重要である。</p>



<p>しかしながら、グローバル市場で今何が起こっているのか、少しは意識しておくことも重要である。なぜなら、このことはおそらく皆さんの次の資金調達ラウンドに影響を与えるからである。</p>



<span id="more-6082"></span>



<p><strong>2022</strong><strong>年に入ってからのマクロイベントを簡単に振り返る。</strong></p>



<p>米国のインフレ率は予想を大幅に上回り、米連邦準備制度理事会（FRB）の多くの関係者は、インフレは単なる一過性のものではないと考えているようである。その結果、パウエル議長は、インフレ抑制のために利上げと量的引き締めを開始する意向を市場に示した。</p>



<p>年明け以降、1兆ドルの資産が引き出され（量的引き締め）、FRBは金利を0.75％引き上げた。</p>



<p>FRBはインフレ抑制に遅れを取っているように見えるため、こうした措置は何かが壊れるまで（つまりモラルが向上するまで）続くと思われる。</p>



<p>この政策転換を受け、米国の株式は急落し、特にゼロ金利を前提とした高成長ハイテク株は急落している。</p>



<p>(DCF（ディスカウントキャッシュフロー）によると、金利が低いと資本コストが低いため、DCFの計算値は高くなる。逆に、金利が上昇すると、資本コストが上昇し、DCF計算の分母が大きくなり、企業の株式価値は急落する）。</p>



<p>株式市場の下落は、通常、他の資産クラスにも影響を与える。例えば、年金基金はポートフォリオのリバランスのためにプライベート・エクイティへの投資を減らす必要があるかもしれない。</p>



<p>タイガー・グローバルのようなクロスオーバー・ヘッジファンドも同様に、<a href="http://rude.vc/u5lj" target="_blank" rel="noreferrer noopener">レイトステージのベンチャー投資を放棄</a>している。より身近なところでは、先週金曜日に<a href="http://rude.vc/nfnV" target="_blank" rel="noreferrer noopener">ソフトバンクのビジョン・ファンド</a>がポートフォリオの2.7兆円の損失と新規のベンチャー投資を減速する意向を発表した。</p>



<p>このようなレイトステージへの投資圧力は、いずれアーリーステージのスタートアップにも波及していくだろう。シリコンバレーでは、最新のY Combinatorの参加者から、最近そのような事例がささやかれ始めている。</p>



<p>しかし、この波が日本のような他のVCエコシステムにどの程度波及するかはまだ不明である。自然キャピタルでは、まだこのような現象に直面していないが、注視しているところである。</p>



<p><strong>では、日本のスタートアップの創業者にとって、この現象はどのような意味を持つのだろうか？</strong></p>



<p>まず、新規の資金調達に時間がかかる可能性がある。VCファンドは、投資ペースを落とし、既存のポートフォリオに注力するため、新規案件に割り当てる資本と時間が少なくなる可能性がある。</p>



<p>伝統的に日本の保守的なVCは、まずは様子見を行うことがあり、特にアーリーステージのスタートアップに対しては、新規の資金調達ラウンドにコミットすることに、さらに長い時間かかるかもしれない。</p>



<p>次に、VCの取引条件がより厳しくなる可能性がある。清算や参加に関する優先権、希薄化防止、ガバナンスコベナンツなどが厳しくなる可能性がある。</p>



<p>最後に、シリーズC、D、E+のレイトラウンドから、バリュエーションが低下する可能性があり、最終的にはシードラウンドやシリーズAラウンドに影響する可能性がある。</p>



<p>シリーズAまたはBラウンドで高い評価額を設定したスタートアップは、パフォーマンスが余程良くない限り、シリーズCラウンドで評価額のハードルをクリアするのに苦労するかもしれない。</p>



<p>ダウンラウンドは破壊的であり、成功確率は低くなる。つまり、前回のラウンドの価格が高すぎたスタートアップは、この環境では新たなラウンドでの資金調達に失敗する可能性があるということである。</p>



<p>SAFEやJ-KISSを重ねているスタートアップは、資本政策で特に難しい難問に直面するかもしれない（<a href="http://rude.vc/uXHZ" target="_blank" rel="noreferrer noopener">起業家の間で人気の資金調達スキーム「SAFE」、さほどセーフ（安全）ではない5つの理由</a>参照）。</p>



<p><strong>悲観的なことばかりではない。</strong></p>



<p>これらを聞くと憂鬱に感じるかもしれないが、私は日本のスタートアップのエコシステムにとって、いくつかの緩和要因、さらにはポジティブな要因もあると考えている。</p>



<p>まず一つの要因は、米国やヨーロッパで起きた評価額の高騰が、日本にはそれほど浸透していないことである。もちろん、例外はあるが、私たちは最近この理由でいくつかの案件を見送った。</p>



<p>もう一つの要因は、日本のスタートアップの製品に対する市場の需要が依然として強固であることである。例えば、日本の企業や医療業界はDXソフトウェアソリューションを切実に必要としており、革新的なスタートアップとの取引を妨げる余裕はない。</p>



<p>さらに、マクロレベルでは、日銀はFRBや欧州中央銀行を追従していない。日銀は、イールドカーブ・コントロールを維持することで、少なくとも今のところは低金利と金融緩和を維持している。(ちなみに、日本円の対ドルでの急激な下落は、この政策の直接的な犠牲者である）。</p>



<p><strong>では、スタートアップの創業者は、これらの課題にどのように対応すれば良いのか？</strong></p>



<p>十分な資本があり、計画通りに事業を推進しているスタートアップは、おそらく何も心配することはない。状況がさらに悪化した場合、マーケットオプチュニティをつかむこともできるかもしれない。</p>



<p>現在、資金調達中のスタートアップにとっては、評価額の期待値を高く設定しすぎるというミスを避けることが賢明であろう。上方修正して下方修正することはいつでも簡単にできる。</p>



<p>さらに、現在資金調達中の創業者は、VCとのディスカッションの状況を正直に評価する必要がある。VCから投資に関する具体的かつ正確な関心を得ているか、あるいは、礼儀として励ましの言葉をかけてもらっているか？VCの投資プロセスはどの程度かかるのか？ラウンドをリードすることができるVCと話をしているか、それともそのVCはフォローすることを好むのか？ （<a href="https://thebridge.jp/2022/03/rudevc-japan-lead-vc-radar-2021" target="_blank" rel="noreferrer noopener"><strong>2021年、日本で最も資金調達をリードしたのはどのVC? インフォグラフィック「日本リードVCレーダー」</strong></a>）</p>



<p>最後にポジティブな点をもう一つ。このようなサイクルは以前よりも圧縮されており、もしこのような辛い経験をしたとしても、それは短時間で終わるかもしれない。このような状況を乗り切った人は、より強くなることであろう。</p>




              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

